import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

let initialized = false;

const initI18n = () => {
  if (!initialized) {
    i18next
      .use(HttpBackend)
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        backend: {
          loadPath: `https://northamerica-northeast1-node-canada.cloudfunctions.net/public/locales?lang={{lng}}&brand=BOS`,
        },
        fallbackLng: 'fr',
        ns: ['translation'],
        defaultNS: 'translation',
        supportedLngs: ['en', 'fr'],
        // Allow language detection to work after initialization
        detection: {
          order: ['localStorage', 'navigator'],
          caches: ['localStorage'],
        },
        // Ensure resources are loaded for language changes
        partialBundledLanguages: true,
        load: 'languageOnly',
      });

    initialized = true;
  }
};

// Function to reset the initialized flag (only use this for troubleshooting)
const resetInitialized = () => {
  initialized = false;
};

export { resetInitialized };
export default initI18n;
